import axiosInstance from './axios'
import { IAxiosResponse, IPaginator } from '../store/ducks/root.types'
import { MAP_TYPE_USER_TO_ENDPOINT, TypesUser } from '../store/application/models/user/user'
import Admin from '../store/application/models/user/admin'
import HealthProfessional from '../store/application/models/user/healthProfessional'
import Navigator from '../store/application/models/user/navigator'


class UserService {

    constructor(private apiVersion: string = 'v1') {
    }

    public create(user: any): Promise<any> {
        let url: string = ''
        switch (user.type) {
            case TypesUser.ADMIN:
                url = `${this.apiVersion}/${MAP_TYPE_USER_TO_ENDPOINT[user.type]}`
                break
            case TypesUser.HEALTH_PROFESSIONAL:
                url = `${this.apiVersion}/${MAP_TYPE_USER_TO_ENDPOINT[user.type]}`
                break
            case TypesUser.NAVIGATOR:
                url = `${this.apiVersion}/${MAP_TYPE_USER_TO_ENDPOINT[user.type]}`
                break
            default:
                url = ''
        }

        return axiosInstance
            .post(url, user)
            .then(response => {
                return user.fromJSON(response.data)
            })
    }

    public getAll(userType: TypesUser, paginator?: IPaginator): Promise<IAxiosResponse<any[]>> {
        const params: URLSearchParams = this.buildParams(paginator)
        return axiosInstance
            .get(`${this.apiVersion}/${MAP_TYPE_USER_TO_ENDPOINT[userType]}`, { params })
            .then((response) => {
                switch (userType) {
                    case TypesUser.ADMIN:
                        return {
                            data: response.data.map(adm => new Admin().fromJSON(adm)),
                            headers: response.headers
                        }
                    case TypesUser.HEALTH_PROFESSIONAL:
                        return {
                            data: response.data.map(hp => new HealthProfessional().fromJSON(hp)),
                            headers: response.headers
                        }
                    case TypesUser.NAVIGATOR:
                        return {
                            data: response.data.map(nv => new Navigator().fromJSON(nv)),
                            headers: response.headers
                        }
                    default:
                        return response.data
                }
            })
    }

    public async getById(userId: string, userType: TypesUser): Promise<IAxiosResponse<any>> {
        return axiosInstance
            .get(`${this.apiVersion}/${MAP_TYPE_USER_TO_ENDPOINT[userType]}/${userId}`)
            .then((response) => {
                switch (userType) {
                    case TypesUser.ADMIN:
                        return {
                            data: new Admin().fromJSON(response.data),
                            headers: response.headers
                        }
                    case TypesUser.HEALTH_PROFESSIONAL:
                        return {
                            data: new HealthProfessional().fromJSON(response.data),
                            headers: response.headers
                        }
                    case TypesUser.NAVIGATOR:
                        return {
                            data: new Navigator().fromJSON(response.data),
                            headers: response.headers
                        }
                    default:
                        return response.data
                }
            })
    }
    public async updade(newUser: any): Promise<IAxiosResponse<any>> {
        return axiosInstance
            .patch(`${this.apiVersion}/${MAP_TYPE_USER_TO_ENDPOINT[newUser.type]}/${newUser.id}`, newUser)
            .then((response) => {
                switch (newUser.type) {
                    case TypesUser.ADMIN:
                        return {
                            data: new Admin().fromJSON(response.data),
                            headers: response.headers
                        }
                    case TypesUser.HEALTH_PROFESSIONAL:
                        return {
                            data: new HealthProfessional().fromJSON(response.data),
                            headers: response.headers
                        }
                    case TypesUser.NAVIGATOR:
                        return {
                            data: new Navigator().fromJSON(response.data),
                            headers: response.headers
                        }
                    default:
                        return response.data
                }
            })
    }
    public async remove(user: any): Promise<IAxiosResponse<any>> {
        return axiosInstance
            .delete(`${this.apiVersion}/${MAP_TYPE_USER_TO_ENDPOINT[user.type]}/${user.id}`)

    }

    public buildParams(paginator?: IPaginator): URLSearchParams {
        const params = new URLSearchParams()
        if (paginator) {
            const hasSearch = (
               (paginator?.search?.key === 'health_professional' ||
                 paginator?.search?.key === 'navigator') && paginator?.search?.value
                )

            if (paginator.page && !hasSearch) {
                params.append('page', String(paginator.page + 1))
            }

            if (paginator.rows) {
                params.append('limit', String(paginator.rows))
            }

            if (hasSearch) {
                params.append("name", `*${paginator?.search?.value}*`)
            }
        }
        return params
    }
}
const userService = new UserService()

export default userService 